const closeButtonLabel = "Închide";
const roRO = {
  closeButtonLabel
};
export {
  closeButtonLabel,
  roRO as default
};
